// Generate code from clean architecture template
/* eslint-disable @typescript-eslint/no-empty-interface */

export enum ConfigValueTypeEnum {
  NUMBER = 'NUMBER',
  STRING = 'STRING',
  BOOLEAN = 'BOOLEAN',
  ARRAY = 'ARRAY',
  OBJECT = 'OBJECT',
  DATE = 'DATE',
}

export enum ConfigKeyEnum {
  DEACTIVATED_PAYMENT_METHOD = 'DEACTIVATED_PAYMENT_METHOD',
  CONTRACT_EXPIRE_CONFIGURATION = 'CONTRACT_EXPIRE_CONFIGURATION',
  POST_CONTRACT_AUDIT_SETTING = 'POST_CONTRACT_AUDIT_SETTING',
  IMPORT_LEAD_FILE_TEMPLATE = 'IMPORT_LEAD_FILE_TEMPLATE',
  CONTRACT_CODE_SETTING = 'CONTRACT_CODE_SETTING',
  SALES_TARGET_RANKING_CONFIGURATION = 'SALES_TARGET_RANKING_CONFIGURATION',
}

export interface ContractManagementColums {
  title?: string;
  status?: boolean;
}
export interface ContractCodeColums {
  key?: string;
  delimiter?: string;
}

export interface ConfigSystemHistoryItem {
  id: string;
  configSystemId: string;
  key: string;
  valueType: string;
  previousValue: string;
  newValue: string;
  action: string;
  createdAt: string;
  createdBy: string;
}

export interface ConfigSystemEntity {
  id?: string;
  key: ConfigKeyEnum;
  value: any;
  valueType: ConfigValueTypeEnum;
  configSystemHistories?: ConfigSystemHistoryItem[];
}

export interface SalesTargetRankingEntity {
  id: string;
  rank: string;
  values: number[];
}
